import { JSX } from "react";

import { MenuItem, Select, type SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";

import PerformersType from "../enum/PerformersType";

function PerformersDropdown({ value, onChange }: { value: number; onChange: (event: SelectChangeEvent) => void }): JSX.Element {
  const { t } = useTranslation();
  const performersTypeNames = Object.values(PerformersType).filter((value) => typeof value === "string");

  return (
    <Select size='small' value={value.toString()} onChange={onChange}>
      {performersTypeNames.map((listItem, index) => (
        <MenuItem key={listItem} value={index}>
          {t(listItem.toString().toLowerCase())}
        </MenuItem>
      ))}
    </Select>
  );
}

export default PerformersDropdown;
